import { Store, VueStore } from "@mgs/ci2019-common/src/store";
import { Product } from "../../common/interfaces/conversionworld/Product";
import { Api } from "../../api";

@Store
export class ConverionWorldProductState extends VueStore {
  public current: Product | null = null;

  public async getProduct(id: number, pageId: number) {
    this.current = await Api.conversionWorldService.getProduct(id, pageId);
  }

  get isElectric() {
    if (this.current) {
      return this.current.is_electric;
    }

    return false;
  }

  get showElectricLogo() {
    if (this.current) {
      return this.current.show_electric_icon;
    }

    return false;
  }
}
